module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Line-126e0467f1a56ff9116b81127b1a3424.svg";